import { useState, useEffect, useCallback } from 'react';
import logger from '../logger';

const useRecaptchaV3 = (siteKey, action) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [token, setToken] = useState(null);
  const [score, setScore] = useState(null);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    const loadScript = () => {
      const existingScript = document.querySelector(`script[src="https://www.google.com/recaptcha/api.js?render=${siteKey}"]`);
      if (existingScript) {
        setIsScriptLoaded(true);
        return;
      }

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.onload = () => {
        setIsLoaded(true);
        setIsScriptLoaded(true);
      };
      script.onerror = () => {
        logger('Failed to load reCAPTCHA script', "error");
        setIsScriptLoaded(false);
      };
      document.head.appendChild(script);
    };

    loadScript();

    return () => {
      const existingScript = document.querySelector(`script[src="https://www.google.com/recaptcha/api.js?render=${siteKey}"]`);
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, [siteKey]);

  const executeRecaptcha = useCallback(async () => {
    let recaptchaEnabled = window?.app_data?.appcmsMain?.security?.reCaptchaKeys?.isEnabled
    if (isScriptLoaded && window.grecaptcha && recaptchaEnabled) {
      try {
        let reCaptchaKeys = window?.app_data?.appcmsMain?.security?.reCaptchaKeys
        const secret = reCaptchaKeys?.secretKey
        return new Promise((resolve, reject) => {
          window.grecaptcha.ready(async () => {
            try {
              const token = await window.grecaptcha.execute(siteKey, { action });
              setToken(token);
              const response = await fetch('/verify-recaptcha', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token,secret })
              });
              const data = await response.json();
              setScore(data.score);
              resolve({ token, score: data.score });
            } catch (error) {
              console.error('Error executing reCAPTCHA:', error);
              reject(null);
            }
          });
        });
      } catch (error) {
        logger(error, "Error preparing reCAPTCHA")
        return null;
      }
    }
    return null;
  }, [isScriptLoaded, siteKey, action]);

  return { executeRecaptcha, token, score };
};

export default useRecaptchaV3;